/** Normaliza texto para busca (sem acento, minúsculas). */
export function normalizeCitySearch(s) {
  return String(s || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

/** Formata nome da cidade (API costuma vir em maiúsculas). */
export function formatCityLabel(c) {
  const raw = String(c?.nome || "").trim();
  const uf = String(c?.uf || "").trim();
  if (!raw) return "—";
  const pretty = raw
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => {
      if (/^\d+$/.test(w)) return w;
      return w.charAt(0).toUpperCase() + w.slice(1);
    })
    .join(" ");
  if (uf && !new RegExp(`(?:^|[\\s/])${uf.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}(?:$|[\\s/])`, "i").test(pretty)) {
    return `${pretty} / ${uf}`;
  }
  return pretty;
}

/** Envia data ao BPe no formato dd/mm/yyyy esperado pela API. */
export function formatDataViagemForApi(value) {
  if (!value) return "";
  const s = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) {
    const [y, m, d] = s.substring(0, 10).split("-");
    return `${d}/${m}/${y}`;
  }
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(s)) return s;
  const [d, m, y] = s.split(/[/-]/);
  if (d && m && y) {
    const yyyy = y.length === 2 ? `20${y}` : y;
    return `${d.padStart(2, "0")}/${m.padStart(2, "0")}/${yyyy}`;
  }
  return s;
}

export function cityPostbackValue(c) {
  if (!c) return "";
  return String(c.postback || c.id || "");
}

export function findCityByPostback(cities, postback) {
  if (!postback || !Array.isArray(cities)) return null;
  const p = String(postback);
  return (
    cities.find((c) => String(c.postback || c.id) === p) ||
    cities.find((c) => String(c.id) === p) ||
    null
  );
}

export function filterCityOptions(options, inputValue, { emptyLimit = 50, matchLimit = 120 } = {}) {
  const list = Array.isArray(options) ? options : [];
  const q = normalizeCitySearch(inputValue);
  if (!q) return list.slice(0, emptyLimit);
  const filtered = list.filter((c) => {
    const blob = normalizeCitySearch(`${c.nome || ""} ${c.uf || ""} ${c.nomecurto || ""}`);
    return blob.includes(q);
  });
  return filtered.slice(0, matchLimit);
}
